<template>
  <div>
    <van-nav-bar
      title="发票抬头详情"
      left-arrow
      @click-left="back"
      style="font-size: 12px;color: #333333;"
    />
    <div class="add-invoice-container">
      <!-- 抬头类型 -->
      <van-radio-group v-model="invoiceType">
        <van-cell-group>
          <van-cell title="企业" clickable @click="invoiceType = 'enterprise'">
            <template #right-icon>
              <van-radio name="enterprise" />
            </template>
          </van-cell>
          <van-cell title="个人/非企业" clickable @click="invoiceType = 'personal'">
            <template #right-icon>
              <van-radio name="personal" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <!-- 发票抬头 -->
      <van-field
        v-model="invoiceTitle"
        label="发票抬头"
        placeholder="请填写发票抬头"
        clearable
      />

      <!-- 纳税人识别号 -->
      <van-field
        v-model="taxNumber"
        label="纳税人识别号"
        placeholder="请填写纳税人识别号"
        clearable
      />

      <!-- 设为默认抬头 -->
      <van-cell title="设为默认抬头">
        <template #right-icon>
          <van-switch v-model="isDefault" size="24" />
        </template>
      </van-cell>



      <!-- 修改和删除按钮 -->
      <van-row v-if="isEdit" class="action-buttons">
        <van-col span="12">
          <van-button type="danger" block @click="deleteInvoice">
            删除
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button type="info" block @click="editInvoice">
            修改
          </van-button>
        </van-col>
      </van-row>
      <!-- 保存按钮 -->
      <van-button type="info" v-else block @click="saveInvoice">
        保存
      </van-button>
    </div>
  </div>
</template>

<script>
import { NavBar, RadioGroup, Radio, CellGroup, Cell, Field, Switch, Button, Row, Col } from 'vant';
import {mapGetters} from "vuex";

export default {
  name: 'InvoiceHeaderManage',
  components: {
    [NavBar.name]: NavBar,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  created() {
    this.isEdit = this.$route.query.isEdit; // 从路由参数中获取 isEdit

    console.log('从父组件传递的参数:', this.isEdit);

    if (this.isEdit) {
      var editHeader = this.$route.query.editHeader; // 从路由参数中获取当前编辑的发票抬头信息
      console.log("editHeade",editHeader)
      this.invoiceType = editHeader.invoiceType == '2' ? 'enterprise' : 'personal';
      this.invoiceTitle = editHeader.title;
      this.oldInvoiceTitle = editHeader.title;
      this.taxNumber = editHeader.taxNumber;
      this.isDefault = editHeader.defaultFlag;
    }

  },
  computed:{
    ...mapGetters({
      trainsLoginInfo: 'tr/trSearchInfo'
    }),
  } ,
  data() {
    return {
      isEdit: false,
      invoiceType: 'enterprise', // 抬头类型：enterprise（企业）或 personal（个人/非企业）
      invoiceTitle: '', // 发票抬头
      oldInvoiceTitle: '', // 旧发票抬头，修改时使用
      taxNumber: '', // 纳税人识别号
      isDefault: false, // 是否设为默认抬头
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    saveInvoice() {

      this.loginInfo = this.trainsLoginInfo['12306Info']
      var params = {
        username:this.loginInfo.trainAccount,
        password:this.loginInfo.password,
        invoiceHeader: this.invoiceTitle,
        creditCode: this.taxNumber,
        invoiceHeaderType: this.invoiceType=='enterprise'?2:1,
        defaultFlag: this.isDefault
      }

      console.log("addInvoiceHeader req{}",params)

      this.$api['trQuery/addInvoiceHeader'](params).then(res => {
        console.log("addInvoiceHeader res{}",res)
        if(res.errCode == '1') {
          this.$toast.success('保存成功');
          this.$router.go(-1);
        }else if(res.errCode == '101' || res.errCode == '100') {
          console.log("登录授权失败"+res.tips)
        } else {
          this.$dialog({
            message: res.errMsg
          })
        }
      }).catch(err => {
        this.errorCatch(err)
      })

      // 这里可以调用接口保存数据，或跳转到其他页面
      this.$toast.success('保存成功');
    },
    editInvoice() {
      // 修改逻辑
      this.loginInfo = this.trainsLoginInfo['12306Info']
      var params = {
        username:this.loginInfo.trainAccount,
        password:this.loginInfo.password,
        newInvoiceHeader: this.invoiceTitle,
        invoiceHeader: this.oldInvoiceTitle,
        creditCode: this.taxNumber,
        invoiceHeaderType: this.invoiceType=='enterprise'?2:1,
        defaultFlag: this.isDefault
      }

      this.$api['trQuery/alterInvoiceHeader'](params).then(res => {
        console.log("alterInvoiceHeader res{}",res)
        if(res.errCode == '1') {
          this.$dialog({
            message: '提交成功'
          })
          this.$toast.success('保存成功');
          this.$router.go(-1);
        }else if(res.errCode == '101' || res.errCode == '100') {
          console.log("登录授权失败"+res.tips)
        } else {
          this.$dialog({
            message: res.errMsg
          })
        }
      })

    },
    deleteInvoice() {
      // 删除逻辑
      console.log('删除发票抬头');
      this.loginInfo = this.trainsLoginInfo['12306Info']
      var params = {
        username:this.loginInfo.trainAccount,
        password:this.loginInfo.password,
        invoiceHeader: this.invoiceTitle,
        creditCode: this.taxNumber
      }

      this.$api['trQuery/delInvoiceHeader'](params).then(res => {
        console.log("delInvoiceHeader res{}",res)
        if(res.errCode == '1') {
          this.$dialog({
            message: '提交成功'
          })
          this.$toast.success('保存成功');
          this.$router.go(-1);
        }else if(res.errCode == '101' || res.errCode == '100') {
          console.log("登录授权失败"+res.tips)
        } else {
          this.$dialog({
            message: res.errMsg
          })
        }
      }).catch(err => {
        this.errorCatch(err)
      })


    },
    errorCatch(err){
      if(err.errCode == '239001' || err.errCode == '239003') {
        this.$toast.clear()
        this.smsCheckMsg = err.tips
        this.$dialog.alert({
          title: '温馨提示',
          message: '根据铁路局规定，你的账号需要先完成短信核验。',
          confirmButtonText: '去核验',
        }).then(async () => {
          this.$refs['verificate'].toggle()
        })

      } else if(err.errCode == '239002') {
        this.$toast.clear()
        this.$refs['face-detection'].toggle()
      }else if(err.errCode == '101' || err.errCode == '100') {
        console.log("登录授权失败 err catch"+err.tips)
      }else {
        console.log("获取发票抬头列表失败")
      }

    }
  },
};
</script>

<style lang="less" scoped>
.add-invoice-container {
  padding: 16px;
  background-color: #fff;

  .van-cell-group {
    margin-bottom: 16px;
  }

  .van-field {
    margin-bottom: 16px;
  }

  .van-button {
    margin-top: 24px;
  }

  .action-buttons {
    margin-top: 24px;

    .van-col {
      padding: 0 8px; // 调整按钮之间的间距
    }
  }
}
</style>
